exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/emergencyPhones.component/styles.less
 ** module id = 612
 ** module chunks = 0
 **/